import PropTypes from 'prop-types';
import React from 'react';

const Eye = ({ color }) => (
  <svg width="25" height="19" viewBox="0 0 25 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M8.41608 0.662027C7.38573 1.01312 5.81897 1.84714 4.93403 2.51509C3.33785 3.72029 1.15095 6.37653 0.301087 8.14246C-0.100362 8.97648 -0.100362 9.14736 0.301087 9.98138C1.92414 13.3537 5.46561 16.563 8.64892 17.5461C14.7507 19.4309 21.037 16.5319 24.3369 10.3118L25 9.06192L24.3369 7.81202C20.9889 1.50142 14.5012 -1.41227 8.41608 0.662027ZM13.9043 3.7036C15.116 4.03998 16.7786 5.38691 17.3524 6.49677C19.0773 9.832 17.0166 13.866 13.2247 14.5775C10.4412 15.0995 7.46041 12.8849 6.89573 9.87528C6.46259 7.56589 8.23134 4.657 10.5724 3.82893C11.9508 3.34119 12.5222 3.31969 13.9043 3.7036ZM10.6468 6.10975C8.4871 7.28156 8.52246 10.8991 10.7045 12.0277C13.0824 13.2572 15.8063 11.6737 15.8063 9.06192C15.8063 6.44613 12.9933 4.83665 10.6468 6.10975Z" fill={color} />
  </svg>

);

Eye.propTypes = {
  color: PropTypes.string.isRequired,
};

export default Eye;
